import { mergeFragments } from "../../mergeFragments";
import base from "./base";
import tenants from "./tenants";
import stripe from "./stripe";
import moneyLabels from "./moneyLabels";
import serviceLeads from "./serviceLeads";
import clientTransactions from "./clientTransactions";
import validation from "./validation";
import planCapabilities from "./planCapabilities";
import gatewayConsole from "./gatewayConsole";
import gatewayShell from "./gatewayShell";
import consultConsole from "./consultConsole";
import affiliate from "./affiliate";
import reviews from "./reviews";
import tenantEntitlements from "./tenantEntitlements";
import giftPromo from "./giftPromo";
import lifecycle from "./lifecycle";
import hqSite from "./hqSite";
import globalData from "./globalData";
import operatorAccess from "./operatorAccess";
import hqCustomers from "./hqCustomers";
import hqAi from "./hqAi";
import automation from "./automation";
import tenant360Sections from "./tenant360Sections";
import tenant360Finance from "./tenant360Finance";
import globalLearn from "./globalLearn";
import customDomains from "./customDomains";
import catalogAndSocial from "./catalogAndSocial";

export default mergeFragments([base, tenants, stripe, moneyLabels, serviceLeads, clientTransactions, validation, planCapabilities, gatewayConsole, gatewayShell, consultConsole, affiliate, reviews, tenantEntitlements, giftPromo, lifecycle, hqSite, globalData, operatorAccess, hqCustomers, hqAi, automation, tenant360Sections, tenant360Finance, globalLearn, customDomains, catalogAndSocial]);
